import { render, staticRenderFns } from "./UpdateProviderParametersButton.vue?vue&type=template&id=70eaa879&"
import script from "./UpdateProviderParametersButton.vue?vue&type=script&lang=js&"
export * from "./UpdateProviderParametersButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports